// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"24627cf7","244":"e94c57e7","312":"63e03b63","414":"5a91f002","416":"e38a249f","672":"0bbd2e15"}[chunkId] + ".chunk.js";
};